// extracted by mini-css-extract-plugin
module.exports = {"item":"redirect_item__1la2a","label":"redirect_label__3eILe"};